import { __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import DaySelectionEdge from './uitk-day-selection-edge.esm.js';
import styles from '../uitk-calendar.css';

var getClassNameList = classNames.bind(styles);
var inRangeEdgeCaseClasses = {
    EndRangeEdge: 'uitk-calendar-day-selection-range-end',
    UnconfirmedEndRangeEdge: 'uitk-calendar-day-selection-range-end',
    SingleDate: 'uitk-calendar-day-selection-range-start',
    StartRangeEdge: 'uitk-calendar-day-selection-range-start',
    UnconfirmedStartAndEndSameDayEdge: 'uitk-calendar-day-selection-range-start',
    WithinRangeFirstOfMonth: 'uitk-calendar-day-selection-in-range-first-of-month',
    WithinRangeLastOfMonth: 'uitk-calendar-day-selection-in-range-last-of-month'
};
var getInRangeBackgroundClass = function (selectionType) {
    return inRangeEdgeCaseClasses[selectionType] || 'uitk-calendar-day-selection-in-range';
};
var DaySelection = function (props) {
    var _a = props.children, children = _a === void 0 ? null : _a, selectionType = props.selectionType;
    var inRangeBackgroundClass = React.useMemo(function () { return getClassNameList('uitk-calendar-day-selection', getInRangeBackgroundClass(selectionType)); }, [selectionType]);
    if (selectionType === 'Unselected') {
        return children ? React.createElement(React.Fragment, null, children) : null;
    }
    var daySelectionProps = {
        className: inRangeBackgroundClass,
        'aria-selected': true
    };
    return (React.createElement("div", __assign({}, daySelectionProps),
        React.createElement(DaySelectionEdge, { selectionType: selectionType }, children)));
};

export { DaySelection as default };
